export const ProductUpdateMixin = {
  props: [],
  data() {
    return {
      itemCount: 1,
      validationMessage: null,
      curentImage: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
      newImages: [],
    }
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      this.product.images = files

      if (this.product.images.length >= 5) {
        this.$toast.error({
          title: 'Error',
          message: 'You can upload up to five images',
          color: '#BD362F',
        })
      }
    },
    editorIsNotEmpty: function(html) {
      if (this.strip(html) == '') {
        return false
      }

      return true
    },
    strip: function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.body.textContent || ''
    },
    getIMG(index, event) {
      var files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        this.product.images[index] = files[0]
        var reader = new FileReader()
        reader.onload = e => this.updateList(index, e.target.result).bind(this)
        reader.readAsDataURL(files[0])
      }
    },
    updateList(index, value) {
      this.newImages[index] = value
      this.newImages = [].concat(this.newImages)
    },
    deletePhoto(index) {
      this.newImages.splice(index, 1)
      this.product.images.splice(index, 1)
    },
    addPhoto() {},
  },
}



// WEBPACK FOOTER //
// ./src/components/mixins/ProductUpdate.mixin.js